if (!customElements.get('collection-products-component')) {
  customElements.define(
    'collection-products-component',
    class CollectionProductsComponent extends HTMLElement {
      constructor() {
        super();
        document.addEventListener('DOMContentLoaded', () => {
          this.initSwiper();
        });
      }

      initSwiper() {
        const container = this.querySelector('.featured-collection__container');
        if (!container) return;

        const swiper = this.querySelector('.my-swiper');
        if (!swiper) return;

        // eslint-disable-next-line no-new, no-undef
        new Swiper(swiper, {
          // Default parameters
          slidesOffsetAfter: 300,
          spaceBetween: 12,
          // Responsive breakpoints
          breakpoints: {
            960: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
            0: {
              slidesPerView: 'auto',
              slidesPerGroup: 1,
            },
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            dynamicBullets: true,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          on: {
            init: function () {
              container.removeAttribute('loading');
            },
          },
        });
      }
    }
  );
}
